import { MuiThemeProvider } from "@material-ui/core/styles"
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles"
import { StylesProvider } from "@material-ui/styles"
import { create } from "jss"
import React from "react"

import { muiClapAndClickFoTheme } from "./muiClapAndClickFoTheme"

const generateClassName = createGenerateClassName()
const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById("jss-insertion-point") || undefined,
})

export const MuiClapAndClickFoThemeProvider: React.FC = (props) => (
  <MuiThemeProvider theme={muiClapAndClickFoTheme}>
    <StylesProvider jss={jss} generateClassName={generateClassName}>
      {props.children}
    </StylesProvider>
  </MuiThemeProvider>
)
